export const PLAYER_FULLSCREEN_DISPLAY_SETTINGS = {
    SET: 'set',
    UNSET: 'unset',
    TOGGLE: 'toggle',
};

export const PLAYER_POSITION_DISPLAY_SETTINGS = {
    FIND_EXTERNAL_SCREEN: 'find-external-screen'
}
